module.exports = __webpack_public_path__ + "img/job.aad52847.svg";